import React, { useState, useEffect } from 'react';
import { 
  BrowserRouter as Router, 
  Routes, 
  Route, 
  Navigate 
} from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Login from './admin/Login';
import Dashboard from './admin/Dashboard';
import BookingPage from './booking/BookingPage';
import { isLoggedIn } from './services/adminService';

// Create material UI theme with blue as primary color
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    // Check if user is already logged in
    if (isLoggedIn()) {
      // Get user data from localStorage
      const savedUser = localStorage.getItem('user');
      if (savedUser) {
        try {
          setUser(JSON.parse(savedUser));
        } catch (error) {
          console.error('Error parsing user data:', error);
        }
      }
    }
    setLoading(false);
  }, []);
  
  const handleLogin = (userData) => {
    console.log('Login success! Setting user data:', userData);
    setUser(userData);
    // Force reload to ensure proper state update
    window.location.reload();
  };
  
  const handleLogout = () => {
    setUser(null);
  };
  
  // Define routes for authenticated and non-authenticated users
  const renderAdminRoutes = () => {
    if (loading) {
      console.log('Loading authentication state...');
      return null; // Don't render anything while checking authentication
    }
    
    if (!user) {
      console.log('User not authenticated, showing login screen');
      return (
        <Route path="/admin/*" element={<Login onLoginSuccess={handleLogin} />} />
      );
    }
    
    console.log('User authenticated, showing dashboard for:', user.username);
    return (
      <Route path="/admin/*" element={<Dashboard user={user} onLogout={handleLogout} />} />
    );
  };
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        
        <Routes>
          {/* Admin routes - must come before the :clinicStub route */}
          {renderAdminRoutes()}
          
          {/* Public booking routes */}
          <Route path="/payment-complete" element={<BookingPage />} />
          <Route path="/booking/payment-complete" element={<BookingPage />} />
          <Route path="/booking/payment-cancelled" element={<BookingPage />} />
          <Route path="/booking/success" element={<BookingPage />} />
          <Route path="/:clinicStub/booking/payment-complete" element={<BookingPage />} />
          <Route path="/:clinicStub/booking/payment-cancelled" element={<BookingPage />} />
          <Route path="/:clinicStub/booking/success" element={<BookingPage />} />
          <Route path="/:clinicStub" element={<BookingPage />} />
          
          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/admin" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;